<template>
  <div class="background-display">
    <v-container fluid class="px-1">
    <Navbar />
    <v-card >
        <v-toolbar dark color="#00b2bb">
          <h1 class="mx-5 my-5 headline font-weight-thin">Ayuda</h1>
        </v-toolbar>
        <v-card-text>
          <div class="text-center">
           <!--  <h1 class="headline-1 my-7 font-weight-thin primary--text">Preguntas Frecuentes</h1> -->
          </div>
          <div class="text-center">
            <h1 class="headline mt-5 font-weight-thin primary--text">{{ title }}</h1>
            <p>Puede contactarnos al siguiente correo</p>
            <a v-bind:href=" `mailto:${email}` " class="mb-5">{{ email }}</a>
          </div>
        </v-card-text>
        <template v-for="(questions, index) in data">
          <v-card :key="index"
            class="ma-5"
            outlined
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4 primary--text">Notaría Ronchera</div>
                <h3 class="subtitle-1 mb-1" disabled v-text="questions.headline"></h3>
                <v-card-text class="text-justify">{{ questions.answers }}</v-card-text>
              </v-list-item-content>

              <v-list-item-avatar
                tile
                size="80"
                class="hidden-xs-only"
              ><v-icon color="primary">mdi-help</v-icon></v-list-item-avatar>
            </v-list-item>
          </v-card>
        </template>
        <v-card-text class="mt-5"></v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<style>
.title-size {
  font-size: 2em;
}
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
.complete-text {
  white-space: normal;
}
</style>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'Help',
  components: {
    Navbar
  },
  data () {
    return {
      title: 'Necesita más Ayuda?',
      description: 'Puede contactarnos de Lunes a Viernes entre las 9 hrs y 18 hrs',
      email: 'ayuda@notariaronchera.cl',
      data: [
        { headline: '1.- CARTA RENUNCIA PERSONA NATURAL:', answers: 'Cuando se pone término al contrato  de trabajo que se mantiene con un empleador que no sea empresa, esta carta poder debe cumplir  con las formalidades que se señalan en el artículo 159 N° 2 del Código de Trabajo, una vez firmada  debe  ser presentado al empleador.-' },
        { headline: '2.- CARTA RENUNCIA EMPRESA:', answers: 'Cuando se pone término al contrato  de trabajo que se mantiene con un empleador que es  empresa, esta carta poder debe cumplir  con las formalidades que se señalan en el artículo 159 N° 2 del Código de Trabajo, una vez firmada  debe  ser presentado al empleador.-' },
        { headline: '3.- DECLARACIÓN JURADA DE CESANTÍA:', answers: 'Esta declaración es requerida por diferentes instituciones para el cobro de seguros, subvenciones y también para suspensiones de pago de créditos, entre otros.-' },
        { headline: '4.- CERTIFICADO DE VIGENCIA DE CONTRATO:', answers: 'Este certificado sirve para muchos trámites tanto para los nacionales como para los extranjeros, es solicitado para trámites en instituciones financieras, renovación de visas, entre otros.-' },
        { headline: '5.- PODER COBRO FINIQUITO:', answers: 'Es importante que en este poder se le da la facultad de ratificar el finiquito, que es la forma en cómo se termina la relación laboral que se tiene con el empleador y la facultad de cobrar los dineros que por ese finiquito se pagan.- ' },
        { headline: '6.- PODER SII PERSONA NATURAL:', answers: 'El tercero, apoderado o mandatario, podrá realizar todas las gestiones ante el Servicio de Impuestos Internos como si fuera el mandante (que es la persona que da poder), para que haga inicio de actividades, para que pueda timbrar boletas,  timbrar libros, solicitar rectificaciones, entre otros.-' },
        { headline: '7.- PODER SII EMPRESA (SOCIEDAD):', answers: 'El tercero, apoderado o mandatario, podrá realizar todas las gestiones ante el Servicio de Impuestos Internos como si fuera el mandante (empresa que da poder) para que haga inicio de actividades, para que pueda timbrar boletas,  timbrar libros, solicitar rectificaciones, entre otros.-' },
        { headline: '8.- PODER REGISTRO CIVIL TRÁMITES VISA:', answers: 'Es el extranjero el que otorga este poder  a un tercero para efectuar trámites ante Registro Civil para obtener visa extranjero.-' },
        { headline: '9.- PODER REGISTRO CIVIL POSESIÓN EFECTIVA:', answers: 'Para que los herederos puedan cobrar la herencia del fallecido, sea desde una pensión o una propiedad, se va a necesitar comenzar con el trámite de posesión efectiva que se realiza ante el Servicio de Registro Civil y, para que el o los herederos no tenga que está haciendo estos trámites se puede entregar este poder a otra persona o a un mismo heredero para que pueda solicitar la posesión efectiva ( así se reconoce claramente quienes son los herederos reales).-' },
        { headline: '10.- DECLARACIÓN JURADA  INHABILITADO ALCOHOLES:', answers: 'Esta declaración es obligatoria para todas las personas que tienen negocios con venta de bebidas alcohólicas, sea botillería, almacén, minimarket, supermercado, bares, etc.- Para que la Municipalidad respectiva pueda otorgar la patente de venta de bebidas alcohólicas, se le va a exigir previamente esta declaración.-' },
        { headline: '11.- DECLARACIÓN  JURADA EXPENSAS:', answers: 'Documento por el cual una persona declara mantener económicamente a otra y todos los gastos los asume el declarante.-' },
        { headline: '12.- DECLARACIÓN  JURADA NO PARTIDO POLÍTICO', answers: 'Esta declaración de no pertenecer a partido político, se encuentra establecida en la Ley Orgánica Constitucional de Partidos Políticos, generalmente  se solicita tanto para poder ingresar a la administración pública, como para ingresar a un partido político. La norma es el artículo 18 de la ley 18.603.-' },
        { headline: '13.- DECLARACIÓN JURADA ART. 56 LEY 18.575 BASES ADMINISTRACIÓN PÚBLICA:', answers: 'Documento por el cual una persona declara que no se encuentra afecta a algunas de las causales de inhabilidades previstas en el artículo Nª 56 de la Ley Nª 18.575 orgánica constitucional de bases generales de la Administración del Estado.' },
        { headline: '14.- CARTA INVITACIÓN EXTRANJERO:', answers: 'El declarante asume toda la responsabilidad de gasto económico del invitado, sea vestimenta, alimentación, salud, entre otros.-' },
        { headline: '15.- DECLARACIÓN JURADA NO CONSUMO DROGAS:', answers: 'Esta declaración se solicita generalmente para ingresar a cargos públicos, también puede ser solicitada para obtener licencia de conducir-' }
      ]
    }
  }
}
</script>
